import { REDUCE_POLICY_VALIDATION_INFO } from '../../constants/actions/policy';

export function reducePolicyValidationInfo(payload) {
    return {
        type: REDUCE_POLICY_VALIDATION_INFO,
        payload,
    };
}
